import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { isMetaInAppBrowser } from "@/lib/inAppBrowser";

export type PetReservaDetalhe = {
  id: number | string;
  nome?: string;
  foto?: string;
  tipo_pet?: string;
  outro_tipo_pet?: string;
  sexo?: string;
  raca?: string;
  idade?: number | string;
  idade_meses?: number | string;
  peso?: number | string;
  data_nascimento?: string;
  porte?: string;
  vacinado?: boolean | number | string;
  comportamento?: string;
  restricoes_alimentares?: string;
  observacoes?: string;
  sociavel_pets?: boolean | number | string;
  sociavel_criancas?: boolean | number | string;
  nivel_energia?: string;
  ambiente_ideal?: string;
  agressivo?: boolean | number | string;
  medo_chuva?: boolean | number | string;
  medo_trovao_fogos?: boolean | number | string;
  toma_medicacao?: boolean | number | string;
  medicacao?: string;
  obs_medicacoes?: string;
  possui_deficiencia?: boolean | number | string;
  tipo_deficiencia?: string;
  tem_alergia?: boolean | number | string;
  alergias?: string;
  alimentacao_especial?: boolean | number | string;
  descricao_alimentacao?: string;
  horario_refeicao?: string;
  horario_passeio?: string;
  dorme_dentro?: boolean | number | string;
  objetos_essenciais?: string;
  aceita_outros_pets?: boolean | number | string;
  ja_ficou_hospedado?: boolean | number | string;
  precisa_espaco_cercado?: boolean | number | string;
  precisa_supervisao_constante?: boolean | number | string;
  vacinas?: {
    id?: number | string;
    vacina_id?: number | null;
    vacina_nome_custom?: string | null;
    nome?: string;
    data_revacinar?: string | null;
    data_aplicacao?: string | null;
    dose_num?: number | null;
    validado?: boolean | number;
  }[];

  parasitas?: {
    id?: number | string;
    tipo?: "antipulgas" | "vermifugo" | string;
    produto?: string;
    data_reaplicar?: string | null;
    data_aplicacao?: string | null;
    validado?: boolean | number;
  }[];
  castrado?: boolean | number | string;
  microchipado?: boolean | number | string;
  microchip_codigo?: string;
  doencas?: string;
  necessidades_especiais?: string;
  vac_multipla_caes?: boolean | number | string;
  vac_multipla_data?: string;
  vac_raiva?: boolean | number | string;
  vac_raiva_data?: string;
  vac_giardia?: boolean | number | string;
  vac_gripe?: boolean | number | string;
  vac_outras?: string;
  usa_antipulgas?: boolean | number | string;
  emergencia?: string;
  contato_medico_vet?: string;
  autoriza_vet?: boolean | number | string;
  autoriza_plantao?: boolean | number | string;
  tag_code?: string;
  tag_url?: string;
  tag_ativa?: boolean | number | string;
};

export type ReservaDetalheModal = {
  id: string | number;
  tutor: string;
  anfitriao?: string;
  tutorId?: string | number;
  telefoneTutor?: string;
  servico?: string;
  modalidadeServico?: string;
  modalidade_servico?: string;
  status?: string;
  dataInicio?: string;
  dataFim?: string;
  horaInicio?: string;
  horaFim?: string;
  checkinRealizadoEm?: string | null;
  checkoutRealizadoEm?: string | null;
  checkin_realizado_em?: string | null;
  checkout_realizado_em?: string | null;
  mensagem?: string;
  valorTotal?: number | string;
  valor_total?: number | string;
  valorLiquido?: number | string;
  valor_liquido?: number | string;
  pagamento?: {
    valorTotal?: number | string;
    valor_total?: number | string;
    valorLiquido?: number | string;
    valor_liquido?: number | string;
  } | null;
  pets?: PetReservaDetalhe[];
  chatUrl?: string | null;
  adicionalCheckoutValor?: number | string | null;
  adicionalCheckoutTipo?: string | null;
  adicionalCheckoutStatus?: string | null;
  checkoutAdicionalUrl?: string | null;
  checkoutAdicionalExternoUrl?: string | null;
  checkoutAdicionalWhatsappUrl?: string | null;
  podeCancelar?: boolean;
  cancelarUrl?: string | null;
  avaliacao?: {
    pode_avaliar?: boolean;
    ja_avaliou?: boolean;
    url?: string | null;
    label?: string | null;
  } | null;
};

type Props = {
  open: boolean;
  reserva: ReservaDetalheModal | null;
  onClose: () => void;
  viewerRole?: "anfitriao" | "tutor";
  onAceitar?: (id: string) => void;
  onRecusar?: (id: string) => void;
  onRealizarCheckin?: (id: string) => void;
  onRealizarCheckout?: (id: string) => void;
  acaoReservaCarregando?: "aceitar" | "recusar" | "checkin" | "checkout" | null;
};

// --- Funções Auxiliares de Formatação ---

function valorOuTraco(valor: unknown) {
  if (valor === null || valor === undefined || valor === "") return "—";
  return String(valor);
}

function textoSimNao(valor: unknown) {
  return valor === true || valor === 1 || valor === "1" || String(valor).toLowerCase() === "sim"
    ? "Sim"
    : "Não";
}

function formatarModalidadeServico(valor?: string | null) {
  if (valor === "banho") return "Banho";
  if (valor === "tosa") return "Tosa";
  if (valor === "banho_e_tosa") return "Banho e Tosa";
  return valor || "";
}

function formatarDataBR(data?: string | null) {
  if (!data) return "—";
  const somenteData = String(data).slice(0, 10);
  const partes = somenteData.split("-");
  if (partes.length !== 3) return String(data);
  return `${partes[2]}/${partes[1]}/${partes[0]}`;
}

function formatarHora(hora?: string | null) {
  if (!hora) return "—";
  return String(hora).slice(0, 5);
}

function formatarDataHoraBR(data?: string | null) {
  if (!data) return "—";
  const dt = new Date(data);
  if (Number.isNaN(dt.getTime())) return String(data);
  return dt.toLocaleString("pt-BR");
}

function formatarMoedaBR(valor?: string | number | null) {
  if (valor === null || valor === undefined || valor === "") return "R$ 0,00";
  let numero: number;
  if (typeof valor === "number") {
    numero = valor;
  } else {
    const limpo = String(valor).replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
    numero = Number(limpo);
  }
  return Number.isNaN(numero) ? 0 : numero.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

function csrfToken() {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || "";
}

function formatarTipoCheckoutAdicional(tipo?: string | null) {
  switch (tipo) {
    case "late_checkout_creche":
      return "Late checkout com cobrança de creche";
    case "late_checkout_diaria_extra":
      return "Late checkout com diária extra";
    case "taxa_atraso_creche":
      return "Taxa de atraso";
    case "nova_creche":
      return "Nova creche";
    default:
      return "Cobrança complementar de checkout";
  }
}

function formatarStatusCheckoutAdicional(status?: string | null) {
  switch (status) {
    case "pago":
      return "Pago";
    case "aguardando_pagamento":
      return "Aguardando pagamento";
    case "pendente":
      return "Pendente";
    case "nao_aplicavel":
      return "Não aplicável";
    default:
      return status ? status.charAt(0).toUpperCase() + status.slice(1).replaceAll("_", " ") : "—";
  }
}

function formatarIdadePet(pet: PetReservaDetalhe) {
  const idadeMeses = Number(pet.idade_meses ?? 0);
  const idadeAnos = Number(pet.idade ?? 0);
  if (idadeMeses > 0) {
    const anos = Math.floor(idadeMeses / 12);
    const meses = idadeMeses % 12;
    if (anos > 0 && meses > 0) return `${anos} ano(s) e ${meses} mês(es)`;
    if (anos > 0) return `${anos} ano(s)`;
    return `${meses} mês(es)`;
  }
  if (idadeAnos > 0) return `${idadeAnos} ano(s)`;
  return pet.data_nascimento ? `Nascimento: ${formatarDataBR(pet.data_nascimento)}` : "—";
}

function dataValida(data?: string | null) {
  if (!data || data === "0000-00-00") return false;
  return !Number.isNaN(new Date(`${String(data).slice(0, 10)}T00:00:00`).getTime());
}

function calcularResumoSaudePet(pet: PetReservaDetalhe) {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  function chaveVacina(v: NonNullable<PetReservaDetalhe["vacinas"]>[number]) {
    if (v.vacina_id) return `id:${v.vacina_id}`;

    const nomeCustom =
      typeof v.vacina_nome_custom === "string"
        ? v.vacina_nome_custom.trim().toLowerCase()
        : "";

    if (nomeCustom) return `custom:${nomeCustom}`;

    const nome =
      typeof v.nome === "string" ? v.nome.trim().toLowerCase() : "";

    if (nome) return `nome:${nome}`;

    return null;
  }

  function chaveParasita(p: NonNullable<PetReservaDetalhe["parasitas"]>[number]) {
    const tipo = typeof p.tipo === "string" ? p.tipo.trim().toLowerCase() : "";
    if (!tipo) return null;
    return tipo;
  }

  const vacinasOriginais = Array.isArray(pet.vacinas) ? pet.vacinas : [];
  const parasitasOriginais = Array.isArray(pet.parasitas) ? pet.parasitas : [];

  const vacinasMap = new Map<string, NonNullable<PetReservaDetalhe["vacinas"]>[number]>();

  vacinasOriginais.forEach((v) => {
    const chave = chaveVacina(v);
    if (!chave || !dataValida(v.data_revacinar)) return;

    const atualMs = new Date(`${String(v.data_revacinar).slice(0, 10)}T00:00:00`).getTime();
    const existente = vacinasMap.get(chave);

    if (!existente) {
      vacinasMap.set(chave, v);
      return;
    }

    const existenteMs = new Date(
      `${String(existente.data_revacinar).slice(0, 10)}T00:00:00`
    ).getTime();

    if (atualMs > existenteMs) {
      vacinasMap.set(chave, v);
    }
  });

  const parasitasMap = new Map<string, NonNullable<PetReservaDetalhe["parasitas"]>[number]>();

  parasitasOriginais.forEach((p) => {
    const chave = chaveParasita(p);
    if (!chave || !dataValida(p.data_reaplicar)) return;

    const atualMs = new Date(`${String(p.data_reaplicar).slice(0, 10)}T00:00:00`).getTime();
    const existente = parasitasMap.get(chave);

    if (!existente) {
      parasitasMap.set(chave, p);
      return;
    }

    const existenteMs = new Date(
      `${String(existente.data_reaplicar).slice(0, 10)}T00:00:00`
    ).getTime();

    if (atualMs > existenteMs) {
      parasitasMap.set(chave, p);
    }
  });

  const vacinas = Array.from(vacinasMap.values());
  const parasitas = Array.from(parasitasMap.values());

  let vacAtrasadas = 0;
  let vacProximas = 0;
  let vacEmDia = 0;

  vacinas.forEach((v) => {
    const data = new Date(`${String(v.data_revacinar).slice(0, 10)}T00:00:00`);
    const diff = Math.floor((data.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));

    if (data < hoje) vacAtrasadas++;
    else if (diff <= 30) vacProximas++;
    else vacEmDia++;
  });

  let parAtrasados = 0;
  let parProximos = 0;
  let parEmDia = 0;

  parasitas.forEach((p) => {
    const data = new Date(`${String(p.data_reaplicar).slice(0, 10)}T00:00:00`);
    const diff = Math.floor((data.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));

    if (data < hoje) parAtrasados++;
    else if (diff <= 30) parProximos++;
    else parEmDia++;
  });

  const total = vacinas.length + parasitas.length;

  let statusGeral = "Sem dados";
  if (total > 0) {
    if (vacAtrasadas > 0 || parAtrasados > 0) statusGeral = "Atrasadas";
    else if (vacProximas > 0 || parProximos > 0) statusGeral = "Próximas";
    else statusGeral = "Em dia";
  }

  return {
    statusGeral,
    vacinas: {
      atrasadas: vacAtrasadas,
      proximas: vacProximas,
      emDia: vacEmDia,
    },
    parasitas: {
      atrasados: parAtrasados,
      proximos: parProximos,
      emDia: parEmDia,
    },
  };
}

export default function ReservaDetalhesModal({
  open,
  reserva,
  onClose,
  viewerRole = "anfitriao",
  onAceitar,
  onRecusar,
  onRealizarCheckin,
  onRealizarCheckout,
  acaoReservaCarregando = null,
}: Props) {
  const [petSelecionado, setPetSelecionado] = useState<PetReservaDetalhe | null>(null);
  const [fichaPetOpen, setFichaPetOpen] = useState(false);
  const inAppBrowser = isMetaInAppBrowser();

  // Guard Clause para evitar renderização sem dados
  if (!open || !reserva) return null;

  function abrirFichaPet(pet: PetReservaDetalhe) {
    setPetSelecionado(pet);
    setFichaPetOpen(true);
  }

  function fecharFichaPet() {
    setFichaPetOpen(false);
    setPetSelecionado(null);
  }

  const pets = Array.isArray(reserva.pets) ? reserva.pets : [];
  const checkinRealizadoEm = reserva.checkinRealizadoEm ?? reserva.checkin_realizado_em ?? null;
  const checkoutRealizadoEm = reserva.checkoutRealizadoEm ?? reserva.checkout_realizado_em ?? null;
  const adicionalCheckoutValor = reserva.adicionalCheckoutValor ?? null;
  const adicionalCheckoutTipo = reserva.adicionalCheckoutTipo ?? null;
  const adicionalCheckoutStatus = reserva.adicionalCheckoutStatus ?? null;
  const checkoutAdicionalUrl = reserva.checkoutAdicionalUrl ?? reserva.checkoutAdicionalExternoUrl ?? null;
  const checkoutAdicionalWhatsappUrl = reserva.checkoutAdicionalWhatsappUrl ?? null;
  const temCheckoutAdicional = Number(adicionalCheckoutValor ?? 0) > 0;
  const avaliacao = reserva.avaliacao ?? null;
  const cancelamentoBloqueadoPorCheckin =
    viewerRole === "tutor" && Boolean(reserva.cancelarUrl) && !reserva.podeCancelar && Boolean(checkinRealizadoEm);
  
  const valorTotalBruto = reserva?.valorTotal ?? reserva?.valor_total ?? reserva?.pagamento?.valorTotal ?? reserva?.pagamento?.valor_total ?? null;
  const valorTotal = typeof valorTotalBruto === "number" && Number.isNaN(valorTotalBruto) ? null : valorTotalBruto;

  const valorLiquidoBruto = reserva?.valorLiquido ?? reserva?.valor_liquido ?? reserva?.pagamento?.valorLiquido ?? reserva?.pagamento?.valor_liquido ?? null;
  const valorLiquido = typeof valorLiquidoBruto === "number" && Number.isNaN(valorLiquidoBruto) ? null : valorLiquidoBruto;
  const valorExibido = viewerRole === "tutor" ? valorTotal : valorLiquido;
  const labelValorExibido = viewerRole === "tutor" ? "Valor total" : "Valor líquido";

  return (
    <>
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
        <Card className="w-full max-w-4xl rounded-3xl border-0 shadow-2xl">
          <CardContent className="max-h-[90vh] overflow-y-auto p-6">
            <div className="mb-5">
              <h3 className="text-xl font-bold text-gray-900">
                Detalhes da reserva
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                {viewerRole === "tutor" ? "Acompanhe os dados da sua reserva." : "Analise os dados da reserva."}
              </p>
            </div>

            <div className="mb-4 space-y-2 rounded-2xl border border-gray-200 bg-gray-50 p-4 text-sm">
              <p>
                <strong>Status:</strong> {valorOuTraco(reserva.status)}
              </p>

              <p>
                <strong>Serviço:</strong> {valorOuTraco(reserva.servico)}
              </p>

              {(reserva.modalidadeServico || reserva.modalidade_servico) && (
                <p>
                  <strong>Modalidade:</strong>{" "}
                  {formatarModalidadeServico(reserva.modalidadeServico || reserva.modalidade_servico)}
                </p>
              )}

              <p>
                <strong>Período:</strong> {formatarDataBR(reserva.dataInicio)}
                {reserva.dataFim && reserva.dataFim !== reserva.dataInicio
                  ? ` até ${formatarDataBR(reserva.dataFim)}`
                  : ""}
              </p>

              {(reserva.horaInicio || reserva.horaFim) && (
                <p>
                  <strong>Horário:</strong> {formatarHora(reserva.horaInicio)} às{" "}
                  {formatarHora(reserva.horaFim)}
                </p>
              )}

              <p>
                <strong>{labelValorExibido}:</strong> {formatarMoedaBR(valorExibido)}
              </p>

              <p>
                <strong>Conversa:</strong>{" "}
                {reserva.chatUrl ? (
                  <a
                    href={reserva.chatUrl}
                    className="font-medium text-blue-600 underline"
                  >
                    Abrir conversa no chat
                  </a>
                ) : (
                  valorOuTraco(reserva.mensagem)
                )}
              </p>

              <p>
                <strong>Check-in:</strong> {checkinRealizadoEm ? formatarDataHoraBR(checkinRealizadoEm) : "Pendente"}
              </p>

              <p>
                <strong>Check-out:</strong> {checkoutRealizadoEm ? formatarDataHoraBR(checkoutRealizadoEm) : "Pendente"}
              </p>
            </div>

            {temCheckoutAdicional && (
              <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-950">
                <p>
                  <strong>Cobrança complementar:</strong> {formatarMoedaBR(adicionalCheckoutValor)}
                </p>
                <p className="mt-1">
                  <strong>Motivo:</strong> {formatarTipoCheckoutAdicional(adicionalCheckoutTipo)}
                </p>
                <p className="mt-1">
                  <strong>Status:</strong> {formatarStatusCheckoutAdicional(adicionalCheckoutStatus)}
                </p>
              </div>
            )}

            <div className="mb-4">
              <h4 className="mb-3 text-sm font-semibold text-gray-700">
                Pets da reserva
              </h4>

              <div className="space-y-4">
                {pets.length === 0 && (
                  <div className="rounded-2xl border border-dashed border-gray-300 p-4 text-sm text-gray-500">
                    Nenhum pet vinculado.
                  </div>
                )}

                {pets.map((pet, index) => (
                  <div
                    key={`${pet.id}-${index}`}
                    className="rounded-[24px] border border-gray-200 bg-white p-4 shadow-sm"
                  >
                    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                      <div className="flex items-center gap-4">
                        <div className="h-16 w-16 shrink-0 overflow-hidden rounded-2xl border border-gray-200 bg-gray-100">
                          {pet.foto ? (
                            <img
                              src={pet.foto}
                              alt={pet.nome || `Pet ${index + 1}`}
                              className="h-full w-full object-cover"
                            />
                          ) : (
                            <div className="flex h-full w-full items-center justify-center text-xs text-gray-400">
                              Sem foto
                            </div>
                          )}
                        </div>

                        <div>
                          <div className="text-xl font-semibold text-gray-900">
                            {pet.nome || `Pet ${index + 1}`}
                          </div>

                          <div className="mt-1 text-sm text-gray-500">
                            {pet.tipo_pet || "Pet"} • {pet.raca || "Sem raça informada"}
                          </div>
                        </div>
                      </div>

                      <Button
                        type="button"
                        onClick={() => abrirFichaPet(pet)}
                        variant="outline"
                        className="rounded-full border-gray-300 bg-white px-5 text-gray-700 hover:bg-gray-50"
                      >
                        Ver ficha completa
                      </Button>
                    </div>

                    <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
                      <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                        <span className="font-semibold">Sexo:</span>{" "}
                        {pet.sexo || "—"}
                      </div>

                      <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                        <span className="font-semibold">Peso:</span>{" "}
                        {pet.peso ? `${String(pet.peso).replace(".", ",")} kg` : "—"}
                      </div>

                      <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                        <span className="font-semibold">Idade:</span>{" "}
                        {formatarIdadePet(pet)}
                      </div>

                      <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                        <span className="font-semibold">Castrado:</span>{" "}
                        {textoSimNao(pet.castrado)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {reserva.status === "pendente" && onAceitar && onRecusar && (
              <div className="mt-6 flex gap-3">
                <Button
                  onClick={() => onAceitar(String(reserva.id))}
                  disabled={acaoReservaCarregando !== null}
                  className="flex-1 rounded-2xl bg-green-600 text-white disabled:opacity-50"
                  type="button"
                >
                  {acaoReservaCarregando === "aceitar" ? "Aceitando..." : "Aceitar"}
                </Button>

                <Button
                  onClick={() => onRecusar(String(reserva.id))}
                  disabled={acaoReservaCarregando !== null}
                  className="flex-1 rounded-2xl bg-red-600 text-white disabled:opacity-50"
                  type="button"
                >
                  {acaoReservaCarregando === "recusar" ? "Recusando..." : "Recusar"}
                </Button>
              </div>
            )}

            {reserva.status === "confirmada" && !checkinRealizadoEm && onRealizarCheckin && (
              <div className="mt-6">
                <Button
                  onClick={() => onRealizarCheckin(String(reserva.id))}
                  disabled={acaoReservaCarregando !== null}
                  className="w-full rounded-2xl bg-amber-500 text-white disabled:opacity-50"
                  type="button"
                >
                  {acaoReservaCarregando === "checkin" ? "Realizando check-in..." : "Realizar check-in"}
                </Button>
              </div>
            )}

            {checkinRealizadoEm && !checkoutRealizadoEm && onRealizarCheckout && (
              <div className="mt-3">
                <Button
                  onClick={() => onRealizarCheckout(String(reserva.id))}
                  disabled={acaoReservaCarregando !== null}
                  className="w-full rounded-2xl bg-sky-600 text-white disabled:opacity-50"
                  type="button"
                >
                  {acaoReservaCarregando === "checkout" ? "Realizando check-out..." : "Realizar check-out"}
                </Button>
              </div>
            )}

            {viewerRole === "tutor" && temCheckoutAdicional && adicionalCheckoutStatus !== "pago" && checkoutAdicionalUrl && (
              <div className="mt-3">
                {inAppBrowser && (
                  <div className="mb-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
                    Você está navegando pelo Instagram/Facebook. Se o pagamento não abrir corretamente,
                    use a opção de abrir no navegador do celular. Você pode continuar por aqui.
                  </div>
                )}
                <Button
                  onClick={() => {
                    window.location.href = checkoutAdicionalUrl;
                  }}
                  className="w-full rounded-2xl bg-amber-500 text-white"
                  type="button"
                >
                  Pagar adicional
                </Button>
              </div>
            )}

            {cancelamentoBloqueadoPorCheckin ? (
              <div className="mt-3">
                <Button
                  type="button"
                  variant="outline"
                  className="w-full rounded-2xl border-gray-200 text-gray-400"
                  disabled
                >
                  Cancelar reserva
                </Button>
              </div>
            ) : viewerRole === "tutor" && reserva.podeCancelar && reserva.cancelarUrl ? (
              <form
                action={reserva.cancelarUrl}
                method="POST"
                className="mt-3"
                onSubmit={(event) => {
                  if (!window.confirm("Tem certeza que deseja cancelar esta reserva?")) {
                    event.preventDefault();
                  }
                }}
              >
                <input type="hidden" name="_token" value={csrfToken()} />
                <Button
                  type="submit"
                  variant="outline"
                  className="w-full rounded-2xl border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
                >
                  Cancelar reserva
                </Button>
              </form>
            ) : null}

            {viewerRole === "anfitriao" && temCheckoutAdicional && adicionalCheckoutStatus !== "pago" && checkoutAdicionalWhatsappUrl && (
              <div className="mt-3">
                <Button asChild className="w-full rounded-2xl bg-emerald-600 text-white" type="button">
                  <a href={checkoutAdicionalWhatsappUrl} target="_blank" rel="noreferrer">
                    Enviar link no WhatsApp
                  </a>
                </Button>
              </div>
            )}

            {avaliacao?.pode_avaliar && avaliacao.url ? (
              <div className="mt-3">
                <Button asChild className="w-full rounded-2xl bg-green-600 text-white" type="button">
                  <a href={avaliacao.url}>
                    {avaliacao.label || (viewerRole === "tutor" ? "Avaliar anfitrião" : "Avaliar tutor")}
                  </a>
                </Button>
              </div>
            ) : avaliacao?.ja_avaliou ? (
              <Button
                disabled
                className="mt-3 w-full rounded-2xl bg-gray-200 text-gray-700 disabled:opacity-100"
                type="button"
              >
                Avaliação enviada
              </Button>
            ) : null}

            <Button
              onClick={onClose}
              className="mt-3 w-full rounded-2xl bg-[#111827] text-white"
              type="button"
            >
              Fechar
            </Button>
          </CardContent>
        </Card>
      </div>

      {fichaPetOpen && petSelecionado && (() => {
        const resumoSaude = calcularResumoSaudePet(petSelecionado);

        return (        
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
            <div
            className="absolute inset-0 bg-black/60"
            onClick={fecharFichaPet}
            />

            <div className="relative z-[201] w-full max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
                <h3 className="text-xl font-semibold text-gray-900">
                Ficha completa do pet
                </h3>

                <button
                type="button"
                onClick={fecharFichaPet}
                className="rounded-full px-3 py-1 text-sm text-gray-500 hover:bg-gray-100"
                >
                Fechar
                </button>
            </div>

            <div className="max-h-[75vh] overflow-y-auto px-6 py-5">
                <div className="mb-6 flex items-center gap-4">
                <div className="h-20 w-20 overflow-hidden rounded-2xl border border-gray-200 bg-gray-100">
                    {petSelecionado.foto ? (
                    <img
                        src={petSelecionado.foto}
                        alt={petSelecionado.nome || "Pet"}
                        className="h-full w-full object-cover"
                    />
                    ) : (
                    <div className="flex h-full w-full items-center justify-center text-xs text-gray-400">
                        Sem foto
                    </div>
                    )}
                </div>

                <div>
                    <div className="text-2xl font-bold text-gray-900">
                    {petSelecionado.nome || "Pet"}
                    </div>
                    <div className="text-sm text-gray-500">
                    {petSelecionado.tipo_pet || "Pet"} • {petSelecionado.raca || "Sem raça informada"}
                    </div>
                </div>
                </div>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Sexo:</span> {petSelecionado.sexo || "—"}
                </div>

                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Peso:</span>{" "}
                    {petSelecionado.peso ? `${String(petSelecionado.peso).replace(".", ",")} kg` : "—"}
                </div>

                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Idade:</span> {formatarIdadePet(petSelecionado)}
                </div>

                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Castrado:</span> {textoSimNao(petSelecionado.castrado)}
                </div>

                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Microchipado:</span> {textoSimNao(petSelecionado.microchipado)}
                </div>

                <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Código do microchip:</span>{" "}
                    {petSelecionado.microchip_codigo || "—"}
                </div>

                  <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Vacinas em dia:</span>{" "}
                    {resumoSaude.vacinas.atrasadas === 0 &&
                    (resumoSaude.vacinas.proximas > 0 || resumoSaude.vacinas.emDia > 0)
                      ? "Sim"
                      : "Não"}
                  </div>

                  <div className="rounded-2xl bg-gray-50 px-4 py-3 text-sm text-gray-700">
                    <span className="font-semibold">Vermifugação em dia:</span>{" "}
                    {resumoSaude.parasitas.atrasados === 0 &&
                    (resumoSaude.parasitas.proximos > 0 || resumoSaude.parasitas.emDia > 0)
                      ? "Sim"
                      : "Não"}
                  </div>
                </div>

                <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="rounded-3xl border border-gray-200 bg-white p-4">
                    <h4 className="mb-3 text-base font-semibold text-gray-900">Saúde</h4>
                    <div className="space-y-2 text-sm text-gray-700">
                    <p><span className="font-semibold">Toma medicação:</span> {textoSimNao(petSelecionado.toma_medicacao)}</p>
                    <p><span className="font-semibold">Medicação:</span> {petSelecionado.medicacao || "—"}</p>
                    <p><span className="font-semibold">Obs. medicações:</span> {petSelecionado.obs_medicacoes || "—"}</p>
                    <p><span className="font-semibold">Tem alergia:</span> {textoSimNao(petSelecionado.tem_alergia)}</p>
                    <p><span className="font-semibold">Alergias:</span> {petSelecionado.alergias || "—"}</p>
                    <p><span className="font-semibold">Possui deficiência:</span> {textoSimNao(petSelecionado.possui_deficiencia)}</p>
                    <p><span className="font-semibold">Tipo de deficiência:</span> {petSelecionado.tipo_deficiencia || "—"}</p>
                    <p><span className="font-semibold">Doenças:</span> {petSelecionado.doencas || "—"}</p>
                    <p><span className="font-semibold">Necessidades especiais:</span> {petSelecionado.necessidades_especiais || "—"}</p>
                    </div>
                </div>

                <div className="rounded-3xl border border-gray-200 bg-white p-4">
                  <h4 className="mb-3 text-base font-semibold text-gray-900">Vacinas e parasitários</h4>

                  <div className="space-y-2 text-sm text-gray-700">
                    <p><span className="font-semibold">Status geral:</span> {resumoSaude.statusGeral}</p>

                    <p>
                      <span className="font-semibold">Vacinas:</span>{" "}
                      Atrasadas: {resumoSaude.vacinas.atrasadas} •
                      Próximas: {resumoSaude.vacinas.proximas} •
                      Em dia: {resumoSaude.vacinas.emDia}
                    </p>

                    <p>
                      <span className="font-semibold">Vermífugos / antiparasitários:</span>{" "}
                      Atrasados: {resumoSaude.parasitas.atrasados} •
                      Próximos: {resumoSaude.parasitas.proximos} •
                      Em dia: {resumoSaude.parasitas.emDia}
                    </p>

                    <p>
                      <span className="font-semibold">Vacinas em dia:</span>{" "}
                      {resumoSaude.vacinas.atrasadas === 0 &&
                      (resumoSaude.vacinas.proximas > 0 || resumoSaude.vacinas.emDia > 0)
                        ? "Sim"
                        : "Não"}
                    </p>

                    <p>
                      <span className="font-semibold">Vermifugação em dia:</span>{" "}
                      {resumoSaude.parasitas.atrasados === 0 &&
                      (resumoSaude.parasitas.proximos > 0 || resumoSaude.parasitas.emDia > 0)
                        ? "Sim"
                        : "Não"}
                    </p>
                  </div>
                </div>

                <div className="rounded-3xl border border-gray-200 bg-white p-4">
                    <h4 className="mb-3 text-base font-semibold text-gray-900">Comportamento</h4>
                    <div className="space-y-2 text-sm text-gray-700">
                    <p><span className="font-semibold">Comportamento:</span> {petSelecionado.comportamento || "—"}</p>
                    <p><span className="font-semibold">Nível de energia:</span> {petSelecionado.nivel_energia || "—"}</p>
                    <p><span className="font-semibold">Ambiente ideal:</span> {petSelecionado.ambiente_ideal || "—"}</p>
                    <p><span className="font-semibold">Sociável com pets:</span> {textoSimNao(petSelecionado.sociavel_pets)}</p>
                    <p><span className="font-semibold">Sociável com crianças:</span> {textoSimNao(petSelecionado.sociavel_criancas)}</p>
                    <p><span className="font-semibold">Aceita outros pets:</span> {textoSimNao(petSelecionado.aceita_outros_pets)}</p>
                    <p><span className="font-semibold">É agressivo:</span> {textoSimNao(petSelecionado.agressivo)}</p>
                    <p><span className="font-semibold">Medo de chuva:</span> {textoSimNao(petSelecionado.medo_chuva)}</p>
                    <p><span className="font-semibold">Medo de trovão/fogos:</span> {textoSimNao(petSelecionado.medo_trovao_fogos)}</p>
                    <p><span className="font-semibold">Já ficou hospedado:</span> {textoSimNao(petSelecionado.ja_ficou_hospedado)}</p>
                    <p><span className="font-semibold">Precisa espaço cercado:</span> {textoSimNao(petSelecionado.precisa_espaco_cercado)}</p>
                    <p><span className="font-semibold">Precisa supervisão constante:</span> {textoSimNao(petSelecionado.precisa_supervisao_constante)}</p>
                    </div>
                </div>

                <div className="rounded-3xl border border-gray-200 bg-white p-4">
                    <h4 className="mb-3 text-base font-semibold text-gray-900">Alimentação e rotina</h4>
                    <div className="space-y-2 text-sm text-gray-700">
                    <p><span className="font-semibold">Restrições alimentares:</span> {petSelecionado.restricoes_alimentares || "—"}</p>
                    <p><span className="font-semibold">Alimentação especial:</span> {textoSimNao(petSelecionado.alimentacao_especial)}</p>
                    <p><span className="font-semibold">Descrição da alimentação:</span> {petSelecionado.descricao_alimentacao || "—"}</p>
                    <p><span className="font-semibold">Horário de refeição:</span> {petSelecionado.horario_refeicao || "—"}</p>
                    <p><span className="font-semibold">Horário de passeio:</span> {petSelecionado.horario_passeio || "—"}</p>
                    <p><span className="font-semibold">Dorme dentro:</span> {textoSimNao(petSelecionado.dorme_dentro)}</p>
                    <p><span className="font-semibold">Objetos essenciais:</span> {petSelecionado.objetos_essenciais || "—"}</p>
                    </div>
                </div>

                <div className="rounded-3xl border border-gray-200 bg-white p-4 md:col-span-2">
                    <h4 className="mb-3 text-base font-semibold text-gray-900">Emergência e observações</h4>
                    <div className="space-y-2 text-sm text-gray-700">
                    <p><span className="font-semibold">Contato de emergência:</span> {petSelecionado.emergencia || "—"}</p>
                    <p><span className="font-semibold">Contato médico veterinário:</span> {petSelecionado.contato_medico_vet || "—"}</p>
                    <p><span className="font-semibold">Autoriza veterinário:</span> {textoSimNao(petSelecionado.autoriza_vet)}</p>
                    <p><span className="font-semibold">Autoriza plantão:</span> {textoSimNao(petSelecionado.autoriza_plantao)}</p>
                    <p><span className="font-semibold">Observações:</span> {petSelecionado.observacoes || "Nenhuma observação informada."}</p>
                    </div>
                </div>
                </div>
            </div>
            </div>
            </div>
        );
      })()}
    </>
  );
}
